import React from 'react';
import PropTypes from 'prop-types';
import {
	makeStyles,
	withStyles,
	Grid,
	Button,
	Typography
} from '@material-ui/core';

import AuthorizedUser from "../utils/AuthorizedUser";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Constants from '../utils/Constants';

const styles = makeStyles(theme => ({
	buttonContainer: {
		"& button": {
			width: "80px",
			[theme.breakpoints.down(365)]: {
				width: "38px"
			},
			display: "inline",
			textAlign: "left",
			height: "40px",
			minWidth: 0,
			minHeight: 0,
			padding: "5px",
			fontSize: "0.9rem",
			textTransform: "none",
			marginRight: "5px",
			marginBottom: "9px",
			boxShadow: "none",
			borderRadius: 0,
			border: `0.5px solid ${theme.palette.primary.lightGrey}`,
			color: theme.palette.secondary.grey,
			backgroundColor: "#fff",

			"&:active": {
				boxShadow: "none"
			}
		}
	},

	label: {
		marginBottom: "5px",
		fontSize: "0.85rem",
		fontWeight: 600
	},

	selected: {
		// color: "#D9DCDD",
		backgroundColor: "#E6F2F4 !important",
	},
}));

function WeekToggleButtons(props) {
	let classes = styles(),
		moreContrast = AuthorizedUser.wantsMoreContrast(),
		{style, disabled, values, buttonToggled, direction} = props;

	return (
		<div className={props.className} style={style}>
			<Typography className={classes.label}>Days</Typography>
			<Grid container direction={direction || "row"} className={classes.buttonContainer} wrap="nowrap">
				<Grid item>
					<Button
						variant="contained"
						disabled={disabled}
						color={values[0] > 0 ?  (moreContrast ? "primary" : "secondary") : "default"}
						aria-label={`Monday, ${values[0] ? "selected" : "unselected"}`}
						classes={{
							containedSecondary: classes.selected
						}}
						endIcon={values[0] > 0 && <FontAwesomeIcon icon={["fas", "check"]} style={{fontSize: "12px", color: "#3e9390", paddingLeft: 15}}/> }
						onClick={() => {buttonToggled(0);}}>Mon</Button>
				</Grid>
				<Grid item>
					<Button
						variant="contained"
						disabled={disabled}
						color={values[1] > 0 ? (moreContrast ? "primary" : "secondary") : "default"}
						aria-label={`Tuesday, ${values[1] ? "selected" : "unselected"}`}
						classes={{
							containedSecondary: classes.selected
						}}
						endIcon={values[1] > 0 && <FontAwesomeIcon icon={["fas", "check"]} style={{fontSize: "12px", color: "#3e9390", paddingLeft: 15}}/> }
						onClick={() => {buttonToggled(1);}}>Tue</Button>
				</Grid>
				<Grid item>
					<Button
						variant="contained"
						disabled={disabled}
						color={values[2] > 0 ? (moreContrast ? "primary" : "secondary") : "default"}
						aria-label={`Wednesday, ${values[2] ? "selected" : "unselected"}`}
						classes={{
							containedSecondary: classes.selected
						}}
						endIcon={values[2] > 0 && <FontAwesomeIcon icon={["fas", "check"]} style={{fontSize: "12px", color: "#3e9390", paddingLeft: 15}}/> }
						onClick={() => {buttonToggled(2);}}>Wed</Button>
				</Grid>
				<Grid item>
					<Button
						variant="contained"
						disabled={disabled}
						color={values[3] > 0 ? (moreContrast ? "primary" : "secondary") : "default"}
						aria-label={`Thursday, ${values[3] ? "selected" : "unselected"}`}
						classes={{
							containedSecondary: classes.selected
						}}
						endIcon={values[3] > 0 && <FontAwesomeIcon icon={["fas", "check"]} style={{fontSize: "12px", color: "#3e9390", paddingLeft: 15}}/> }
						onClick={() => {buttonToggled(3);}}>Thu</Button>
				</Grid>
				<Grid item>
					<Button
						variant="contained"
						disabled={disabled}
						color={values[4] > 0 ? (moreContrast ? "primary" : "secondary") : "default"}
						aria-label={`Friday, ${values[4] ? "selected" : "unselected"}`}
						classes={{
							containedSecondary: classes.selected
						}}
						endIcon={values[4] > 0 && <FontAwesomeIcon icon={["fas", "check"]} style={{fontSize: "12px", color: "#3e9390", paddingLeft: 25}}/> }
						onClick={() => {buttonToggled(4);}}>Fri</Button>
				</Grid>
				<Grid item>
					<Button
						variant="contained"
						disabled={disabled}
						color={values[5] > 0 ? (moreContrast ? "primary" : "secondary") : "default"}
						aria-label={`Saturday, ${values[5] ? "selected" : "unselected"}`}
						classes={{
							containedSecondary: classes.selected
						}}
						endIcon={values[5] > 0 && <FontAwesomeIcon icon={["fas", "check"]} style={{fontSize: "12px", color: "#3e9390", paddingLeft: 15}}/> }
						onClick={() => {buttonToggled(5);}}>Sat</Button>
				</Grid>
				<Grid item>
					<Button
						variant="contained"
						disabled={disabled}
						color={values[6] > 0 ? (moreContrast ? "primary" : "secondary") : "default"}
						aria-label={`Sunday, ${values[6] ? "selected" : "unselected"}`}
						classes={{
							containedSecondary: classes.selected
						}}
						endIcon={values[6] > 0 && <FontAwesomeIcon icon={["fas", "check"]} style={{fontSize: "12px", color: "#3e9390", paddingLeft: 15}}/> }
						onClick={() => {buttonToggled(6);}}>Sun</Button>
				</Grid>
			</Grid>
		</div>
	);
}

WeekToggleButtons.propTypes = {
	style: PropTypes.object,
	className: PropTypes.string,
	disabled: PropTypes.bool,
	values: PropTypes.array,
	buttonToggled: PropTypes.func,
	direction: PropTypes.string
};

export default WeekToggleButtons;
